import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/graphic/query_page";
export const Download = '/icps/system/sign/basics/graphic/exportTemplate'

/*根据工程id获取图算列表*/
export function graphic_list(params) {
  return request({
    url: "/icps/system/sign/basics/graphic/graphic_list",
    method: "get",
    params,
  });
}
/*新增或修改*/
export function save_or_update(data) {
  return request({
    url: "/icps/system/sign/basics/graphic/save_or_update",
    method: "post",
    data,
  });
}
/*获取强度等级和性能要求等。。。*/
export function getLists(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/getLists",
    method: "post",
    data,
  });
}
